
export const UPDATE_SEARCHTDATA_TAIKHOAN_BANK = "UPDATE_SEARCHTDATA_TAIKHOAN_BANK";
export const UPDATE_SEARCHTDATA_LICHSU_BANK = "UPDATE_SEARCHTDATA_LICHSU_BANK";
export const UPDATE_SEARCHTDATA_CHOTHANHTOAN = "UPDATE_SEARCHTDATA_CHOTHANHTOAN";


